import { REDUCER_NAME, State } from './index';

interface PartialState {
	[REDUCER_NAME]: State;
}

export const rankMessageSelector = (state: PartialState) => state[REDUCER_NAME].rankMessage;
export const gameCodesSelector = (state: PartialState) => state[REDUCER_NAME].gameCodes;
